import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { VerticalStepperService } from '../../../services/vertical-stepper/vertical-stepper.service';
import { map, Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'irembogov-custom-field-stepper',
  templateUrl: './custom-field-stepper.component.html',
})
export class CustomFieldStepperComponent extends FieldType {
  validSelectedIndex$: Observable<number>;

  constructor(public verticalStepperService: VerticalStepperService) {
    super();

    this.validSelectedIndex$ =
      this.verticalStepperService.selectedIndexObservable$.pipe(
        map(globalIndex => {
          const fields = this.filterFields();

          // If global index is out of bounds for this stepper, return 0
          if (globalIndex >= fields.length) {
            return 0;
          }

          return Math.max(0, globalIndex);
        })
      );
  }

  filterFields() {
    return (
      this.field.fieldGroup?.filter?.(
        (x: any) => !x.hide && !x.props?.hideField
      ) ?? []
    );
  }
}
